<template>
  <form v-on:submit.prevent="createBed">
    <div class="modal-card" >
      <header class="modal-card-head">
        <p class="modal-card-title">Crear cama</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
          <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="true"></b-loading>
        <b-field label="N° de cama">
            <b-input v-model="dataBed.n_cama"></b-input>
        </b-field>
        <b-field label="Estado de la cama por defecto">
            <b-select v-model="dataBed.state" expanded required>
                <option value="HABILITADA">HABILITADA</option>
                <option value="BLOQUEADA">BLOQUEADA</option>
            </b-select>
        </b-field>
        <b-field label="Establecimiento" >
            <b-select placeholder="Seleccionar Establecimiento" expanded v-model="dataBed.stablishment_id" @change.native="changeStablishment" required>
                <option
                    v-for="option in listStablishment"
                    :value="option.id"
                    :key="option.id">
                    {{ option.name }}
                </option>
            </b-select>
        </b-field>
        <b-field label="Categorización">
            <b-select placeholder="Seleccionar Categorización" expanded v-model="dataBed.categorization_id" @change.native="changeCategorization" required>
                <option
                    v-for="option in listCategorization"
                    :value="option.id"
                    :key="option.id">
                    {{ option.name }}
                </option>
            </b-select>
        </b-field>
        <b-field label="Subcategorización" >
            <b-select placeholder="Seleccionar Subcategorización" expanded v-model="dataBed.subcategorization_id" required>
                <option
                    v-for="option in listSubCategorization"
                    :value="option.id"
                    :key="option.id">
                    {{ option.name }}
                </option>
            </b-select>
        </b-field>   
        <b-field label="Con ventilador">
            <b-select placeholder="Seleccionar opción" expanded v-model="dataBed.ventilator" required>
                 <option value="si">Si</option>
                <option value="no">No</option>
            </b-select>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$emit('close')" >
          Cerrar
        </button>
        <button class="button is-primary" type="submit">Guardar</button>
      </footer>
    </div>
  </form>
</template>
<script>
import { PostBed } from '../../../services/beds';
import { CategorizationFindByStablishmentId } from '../../../services/categorization';
import {GetAllStablishment} from '../../../services/stablishment';
import { SubCategorizationFindByCategorizationId } from '../../../services/subCategorization';
import { eventBus } from "../../../main";
export default {    
    data(){
        return{
            dataBed:{
                state:'HABILITADA',
                ventilator:'no'
            },             
            listStablishment:[],
            listCategorization:[],
            listSubCategorization:[],
            isLoading:false,
        }
    },
    mounted(){
        this.chargeData();
    },
    methods:{
        async chargeData(){
            this.isLoading=true;
            this.listStablishment=await GetAllStablishment(this.$http);            
            this.isLoading=false;
        },
        async createBed(){
            this.isLoading=true;
            await PostBed(this.$http,this.dataBed);
            eventBus.$emit('rechargeTableManteinerBeds');          
            this.$parent.close();  
            this.isLoading=false;
        },
        async changeStablishment(){
            this.isLoading=true;
            this.listCategorization=await CategorizationFindByStablishmentId(this.$http,this.dataBed.stablishment_id);
            this.dataBed.categorization_id=this.listCategorization[0].id;
            this.changeCategorization();
            this.dataBed.subcategorization_id=null;
             this.isLoading=false;
        },
        async changeCategorization(){
            this.isLoading=true;
            this.listSubCategorization=await SubCategorizationFindByCategorizationId(this.$http,this.dataBed.categorization_id);            
            this.dataBed.subcategorization_id=this.listSubCategorization[0].id;
            this.isLoading=false;
        }
    }
}
</script>